<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Danh sách"
          :link="[
            { text: 'Cơ sở vật chất', href: '/facility' },
            { text: 'Đầu mục thiết bị', href: '/facility/categories' }
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn depressed dark color="primary" @click="newDialog = !newDialog">
          <v-icon left>mdi-plus</v-icon> Thêm đầu mục
        </v-btn>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <CategoryFilter ref="categoryFilter" @onFilterChanged="onFilterChange" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <CategoryDataTable ref="categoryDataTable" />
    </v-card>

    <CategoryNewDialog :state="newDialog" @updated="onCategoryUpdated" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import CategoryDataTable from '@/modules/facility/category/CategoryDataTable.vue'
import CategoryFilter from '@/modules/facility/category/CategoryFilter.vue'

export default {
  name: 'FacilityCategories',
  components: {
    Breadcrumbs,
    CategoryDataTable,
    CategoryFilter,
    CategoryNewDialog: () => import('@/modules/facility/category/CategoryNewDialog.vue')
  },
  data() {
    return {
      newDialog: false,
      currentFilter: {}
    }
  },
  methods: {
    async refresh(query) {
      this.$refs.categoryDataTable.refresh(query)
    },
    onFilterChange(query) {
      this.currentFilter = query || {}
      this.refresh(this.currentFilter)
    },
    onCategoryUpdated() {
      this.refresh(this.currentFilter)
      if (this.$refs.categoryFilter && this.$refs.categoryFilter.loadRootCategories) {
        this.$refs.categoryFilter.loadRootCategories()
      }
    }
  }
}
</script>
